import React, { useState } from "react";
import styles from "./PaymentDetails.module.scss";
import CustomButton from "../../../../components/Button/CustomButton";
import EMIsAPI from "../../../../services/emi-api";
import { rozarLoanPayment } from "../../../../lib/payments";
import Swal from "sweetalert2";

export default function PaymentDetails({ amount }) {
  const [partPaymentAmount, setPartPaymentAmount] = useState("");
  const [paymentType, setPaymentType] = useState("full");

  const { createOrderPaymentAPI } = new EMIsAPI();

  const handlePaymentOrder = async () => {
    if (paymentType === "full") {
      const res = await createOrderPaymentAPI(amount);
      if (res.statusCode === 200) {
        await rozarLoanPayment(res.data);
      }
    } else {
      if (partPaymentAmount >= 100) {
        const res = await createOrderPaymentAPI(partPaymentAmount);
        if (res.statusCode === 200) {
          await rozarLoanPayment(res.data);
        }
      } else {
        Swal.fire({
          icon: "warning",
          text: "Input amount should be between ₹ 100 - ₹" + amount,
        });
      }
    }
  };

  return (
    <div className={styles.paymentDetails}>
      <div
        className={`${styles.paymentList} ${paymentType === "full" ? styles.active : ""}`}
        onClick={() => setPaymentType("full")}
      >
        <div className={styles.titleBlock}>
          <div className={styles.radio}>
            <div />
          </div>
          <div className={styles.title}>Full Payment</div>
        </div>

        {paymentType === "full" && (
          <div className={styles.totalPayable}>
            <div>Total amount to pay</div>
            <div className={styles.paymentAmount}>₹{amount}</div>
          </div>
        )}
      </div>

      <div
        className={`${styles.paymentList} ${paymentType === "part" ? styles.active : ""}`}
        onClick={() => setPaymentType("part")}
      >
        <div className={styles.titleBlock}>
          <div className={styles.radio}>
            <div />
          </div>
          <div className={styles.title}>Part Payment</div>
        </div>

        {paymentType === "part" && (
          <>
            <div className={styles.totalPayable}>
              <div>Total amount to pay</div>
              <div className={styles.paymentAmount}>₹{amount}</div>
            </div>

            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Part - Payment Amount"
                autoComplete="off"
                onChange={(e) => setPartPaymentAmount(e.target.value)}
              />
              <div className={styles.amountLeft}>Amount left: ₹{amount - partPaymentAmount}</div>
            </div>
          </>
        )}
      </div>

      <div style={{ height: 100 }} />

      <div className={styles.bottomButton}>
        <img src="/images/rozar-pay.png" alt="" />
        <CustomButton text="Pay Now" onClick={handlePaymentOrder} />
      </div>
    </div>
  );
}
